export const scrollToId = (id: string, useView = true, options: ScrollToOptions | ScrollIntoViewOptions = {}) => {
  if (import.meta.server || !id) return

  const el = document.getElementById(id)
  if (!el) return

  if (useView) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      ...options,
    })
    return
  }
  window.scrollTo({
    top: el.offsetTop,
    behavior: 'smooth',
    ...options,
  })
}
